import { IndustryParams } from "../../../legacy/types/companyFilter";

/**
 * Transforms SAM industry configuration to CompanyFilter industry format
 *
 * @param industry SAM industry configuration
 * @param baseIndustry Existing industry filter to extend
 * @returns Updated industry filter
 */
export const transformSamIndustry = (
  industry: {
    ids?: number[];
    sicIds?: string[];
    naicsIds?: string[];
    excludedIds?: number[];
    excludedSicIds?: string[];
    excludedNaicsIds?: string[];
  },
  baseIndustry?: IndustryParams
) => {
  const result = { ...baseIndustry } as IndustryParams;

  if (industry.ids?.length) {
    result.industryIds = industry.ids;
  }

  if (industry.sicIds?.length) {
    result.sicUS1987Ids = industry.sicIds;
  }

  if (industry.naicsIds?.length) {
    result.naics2012Ids = industry.naicsIds;
  }

  if (industry.excludedIds?.length) {
    result.excludedIndustryIds = industry.excludedIds;
  }

  if (industry.excludedSicIds?.length) {
    result.excludedSicUS1987Ids = industry.excludedSicIds;
  }

  if (industry.excludedNaicsIds?.length) {
    result.excludedNaics2012Ids = industry.excludedNaicsIds;
  }

  return result;
};
